import * as React from "react";
import { useTheme } from "@mui/material/styles";
import {
	Box,
	Typography,
	Grid,
	Checkbox,
	FormControlLabel,
} from "@mui/material";
import Audio from "../../../ui-components/Audio";

export default function CheckBox({ question, onAnswer = () => {} }) {
	const theme = useTheme();
	const [answers, setAnswers] = React.useState([]);

	React.useEffect(() => {
		setAnswers([]);
	}, [question]);

	const handleToggleAnswer = (value) => {
		let newAnswers = [...answers];

		if (newAnswers.indexOf(value) === -1) {
			newAnswers.push(value);
		} else {
			newAnswers = newAnswers.filter((ans) => ans !== value);
		}

		setAnswers(newAnswers);

		const canProceed = newAnswers.length > 0;

		onAnswer({
			canProceed,
			answer: newAnswers,
		});
	};

	return (
		<React.Fragment>
			<Box
				className="choices-container"
				sx={{ px: 4, textAlign: "center" }}
			>
				{question.questionAudio && (
					<Audio audioText={question.questionAudio} />
				)}
				{question.questionImage && (
					<img
						src={`https://s3.ap-southeast-2.amazonaws.com/static.lln.training/acsf3-short-quiz-resources/${question.questionImage}`}
						alt="Question Illustration"
						style={{ width: "100%", marginTop: "20px" }}
					/>
				)}

				{question.clipart && (
					<img
						src={`clipart/${question.clipart}`}
						style={{
							maxWidth: "5rem",
							position: "absolute",
							marginLeft: "-5rem",
						}}
						alt="Clipart"
					/>
				)}

				{question.questionList.map((q, i) => {
					return (
						<Grid
							container
							sx={{ mt: 1, width: "100%" }}
							key={`cb-question-${i}-${Math.random()}`}
						>
							<Grid
								item
								sx={{
									display: "flex",
									alignItems: "center",
									width: "100%",
								}}
								className={`audio-question-container question-cb ${
									answers.indexOf(q.value) >= 0
										? "selected"
										: ""
								}`}
								onClick={() => handleToggleAnswer(q.value)}
							>
								<FormControlLabel
									control={
										<Checkbox
											color="primary"
											sx={{ display: "none" }}
										/>
									}
									label={
										<Typography
											className="cb-choice-label"
											sx={{
												color: theme.palette.primary
													.main,
												// fontWeight: "bold",
												margin: 0,
											}}
										>
											{q.label || q.value}
										</Typography>
									}
								/>
							</Grid>
						</Grid>
					);
				})}
			</Box>
		</React.Fragment>
	);
}
